import React, {PureComponent} from 'react';
import BEMHelper from 'react-bem-helper';
import Notice from '../ListEntity/Entities/Notice';
import Article from '../ListEntity/Entities/Article';
import Modal from '../Render/Modal/Modal';
import Form from './Form';

const bem = new BEMHelper({
  name: 'select-entities',
  prefix: 'planet-'
});

class Component extends PureComponent {

  state = {isOpen: false};

  toggleOpenModal = () => {
    this.setState({isOpen: !this.state.isOpen});
  };

  render() {
    const {entity, list = [], section} = this.props;
    const Comp = entity === 'Article' ? Article : Notice;

    return (
      <div {...bem()}>
        <div {...bem('actions')}>
          <button
            onClick={this.toggleOpenModal}
            type="button"
            className="btn btn-primary">EDIT
          </button>
        </div>
        <div className="row">
          {
            list.map((val, index) => {
              return (
                <div
                  key={index}
                  className="col-sm-4"><Comp {...val}/></div>
              );
            })
          }
        </div>

        <Modal
          toogle={this.toggleOpenModal}
          isOpen={this.state.isOpen}>
          <Form close={this.toggleOpenModal} section={section} entity={entity}/>
        </Modal>
      </div>
    );
  }
}

Component.propTypes = {};
Component.defaultProps = {};

export default Component;



// WEBPACK FOOTER //
// ./src/components/select-entities/index.js